import { Component, Host, h } from '@stencil/core';
export interface AhaTabPanel extends HTMLAhaTabPanelElement {}

/**
 * @slot Default - Contents of `aha-tab-panel`
 */
@Component({
  tag: 'aha-tab-panel',
  styleUrl: 'aha-tab-panel.css',
  shadow: true,
})
export class AhaTabPanel {
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
